import { FC, useEffect, useState } from "react";
import { formatPhoneNumber } from "src/helpers";
import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { useNavigate } from "react-router-dom";
import { ManufactureInsuranceInformationProps,ManufactureInsuranceInformation } from "./type";

const ManufactureInsuranceInformations: FC<ManufactureInsuranceInformationProps> = ({ caseId, insuranceInformation, insuranceNumber, drugName }): JSX.Element => {
  const [precertPathParameters, setPrecertPathParameters] = useState<{ caseId: number; precertId: number }>({ caseId: 0, precertId: 0 })

  const navigate = useNavigate();



  const { mutate: fetchPrecertMutate, data: fetchPrecertResponse } =
    useFetch<{ code:number; message:string;}>(APIEndpoints.FETCH_PRECERT, {}, {}, false);

  useEffect(() => {
    if (fetchPrecertResponse)
      navigate(`/cases/${precertPathParameters && precertPathParameters.caseId}/precerts/${precertPathParameters && precertPathParameters.precertId}/edit`);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchPrecertResponse]);



  const navigateToPrecertForm = (caseId: number, precertId: number) => {
    const pathParams = {
      case_id: caseId,
      id: precertId
    }
    setPrecertPathParameters({ caseId, precertId })
    fetchPrecertMutate({}, pathParams)
  }

  const precertCheck = (item: ManufactureInsuranceInformation) => {
    if (item.precert_present && item.precert_editable) {
      return (
        <button
          className="btn btn-green btn-sm"
          onClick={() => { item.precert_id && navigateToPrecertForm(caseId || 0, item.precert_id) }}
        >
           Precert
        </button>
      )
    } else if (item.precert_present) {
      return <p>{item.precert}</p>
    } else {
      return <p>N/A</p>
    }
  }

  return (
    <div className="card mb-2">
      <div className={`card-header pb-3 ${drugName === 'iovera°' ? 'iovera-theme' : 'zilretta-theme'}`}>
        <h4 className="mb-0 text-center">
          Insurance # {insuranceNumber}: {insuranceInformation ? insuranceInformation.insurance_priority : 'N/A'}
        </h4>
      </div>

      <div className="card-body">
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className={"form-label"}>Relation to Patient:</label>
              </div>
              <div className="col-6">
                <p>
                  {insuranceInformation ? insuranceInformation.relation_to_patient : 'N/A'}
                </p>
              </div>
            </div>
          </div>

          {insuranceInformation && insuranceInformation.relation_to_patient !== "Self" ? (
            <>
              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end px-3">
                    <label className={"form-label"}>Relation First Name:</label>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation ? insuranceInformation.relation_first_name : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end px-3">
                    <label className={"form-label"}>Relation Middle Name:</label>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation ? insuranceInformation.relation_middle_name : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end px-3">
                    <label className={"form-label"}>Relation Last Name:</label>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation ? insuranceInformation.relation_last_name : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>
            </>
          ) : <div className="col-6"></div>}

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className={"form-label"}>Plan Name:</label>
              </div>
              <div className="col-6">
                <p>
                  {insuranceInformation ? insuranceInformation.plan_name : 'N/A'}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className={"form-label"}>Plan Type:</label>
              </div>
              <div className="col-6">
                <p>
                  {insuranceInformation ? insuranceInformation.plan_type : 'N/A'}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Medical Insurance */}
        <div className="card my-4 rounded-1">
          <div className={`card-header ${drugName === 'iovera°' ? 'iovera-theme' : 'zilretta-theme'}`}>
            <h4 className="mb-0">Medical Insurance</h4>
          </div>

          <div className="card-body">
            <div className="row">

              {/* <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end px-3">
                    <label className={"form-label"}>Member ID:</label>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation ? insuranceInformation.member_id : 'N/A'}
                    </p>
                  </div>
                </div>
              </div> */}

              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end px-3">
                    <label className={"form-label"}>Group:</label>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation ? insuranceInformation.group : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end px-3">
                    <label className={"form-label"}>Insurance Phone:</label>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation && insuranceInformation.insurance_phone && insuranceInformation.insurance_phone !== 'N/A' ? formatPhoneNumber(insuranceInformation.insurance_phone) : "N/A"}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end px-3">
                    <label className={"form-label"}>Precert:</label>
                  </div>
                  <div className="col-6">
                    {precertCheck(insuranceInformation)}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Pharmacy Insurance */}
        {drugName === "zilretta" && 
        <div className="card my-2 mb-0 rounded-1">
          <div className={`card-header zilretta-theme}`}>
            <h4 className="mb-0">Pharmacy Insurance</h4>
          </div>

          <div className="card-body">
            <div className="row">

              {/* <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end px-3">
                    <label className={"form-label"}>Rx Member ID:</label>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation ? insuranceInformation.rx_member_id : 'N/A'}
                    </p>
                  </div>
                </div>
              </div> */}

              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end px-3">
                    <label className={"form-label"}>Rx Group:</label>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation ? insuranceInformation.rx_group : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end px-3">
                    <label className={"form-label"}>BIN:</label>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation ? insuranceInformation.bin : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end px-3">
                    <label className={"form-label"}>PCN:</label>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation ? insuranceInformation.pcn : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end px-3">
                    <label className={"form-label"}>Prior Authorization:</label>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation ? insuranceInformation.prior_authorization : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>}
      </div>
    </div>
  );
};

export default ManufactureInsuranceInformations;
